var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHello(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "164px",
    height: "164px",
    viewBox: "0 0 164 164",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graphic-hello") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "finlistics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cd-6",
    transform: "translate(-1991.000000, -1697.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graphic-hello",
    transform: "translate(1991.000000, 1697.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graphic-learners",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 82,
    cy: 82,
    r: 82
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 38,
    y: 48,
    width: 92,
    height: 42
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(27.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 0.544643)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 123,
    height: 97
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.2920105,35.5446429 C35.8892542,35.5446429 41,46.2669696 41,73.5446429 C41,74.1614311 43.0955003,75.3028882 47.286501,76.9690141 C53.3857509,76.8512565 79.7642278,71.8967927 81,70.5446429 C92.2164587,58.2718854 81.8126155,35.5446429 63.2920105,35.5446429 Z",
    id: "Oval",
    fill: "#FAC036",
    opacity: 0.894042969
  }), /*#__PURE__*/React.createElement("g", {
    id: "Emoji_u1f44b",
    transform: "translate(18.000000, 3.544643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 7.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2656034,40.0322124 C19.5923276,40.6611504 18.912931,39.9100885 18.912931,39.9100885 C18.912931,39.9100885 7.60189655,27.9541593 6.86741379,27.4168142 C5.83301724,26.6657522 3.61732759,25.4872566 1.40163793,27.7648673 C0.477413793,28.7113274 -1.02827586,30.8179646 1.76887931,34.2130088 C2.37482759,34.9457522 19.9962931,53.4719469 21.024569,54.4733628 C21.024569,54.4733628 29.1650862,62.3747788 34.0922414,65.3484956 C35.4571552,66.1728319 36.9934483,67.0460177 38.7868103,67.6566372 C40.5740517,68.2672566 42.5938793,68.6885841 44.7238793,68.6885841 C46.8538793,68.7130088 49.0634483,68.3038938 51.1506034,67.5406195 C53.2377586,66.7712389 55.1841379,65.6538053 56.9530172,64.3653982 C57.3875862,64.0356637 57.8282759,63.7059292 58.2383621,63.3517699 L59.4257759,62.3747788 C60.252069,61.6847788 61.0232759,60.9581416 61.7638793,60.219292 C63.2512069,58.7415929 64.5916379,57.1600885 65.772931,55.5419469 C66.9481034,53.9176991 67.9457759,52.2384956 68.7414655,50.5653982 C69.5371552,48.8923009 70.0941379,47.2130973 70.4307759,45.6254867 C70.7857759,44.0439823 70.8837069,42.5479646 70.8286207,41.2412389 C70.8163793,39.9345133 70.5531897,38.8170796 70.3389655,37.9255752 C70.0941379,37.0340708 69.8309483,36.3684956 69.6228448,35.9288496 C69.4208621,35.4892035 69.3106897,35.2571681 69.3106897,35.2571681 L69.3106897,35.2571681 C69.0291379,34.469469 68.7598276,33.7184071 68.5211207,33.0406195 C67.8478448,31.1293805 67.0705172,28.9861062 66.2625862,26.7817699 C65.9198276,25.8475221 65.7606897,25.4261947 65.7606897,25.4261947 L65.7668103,25.4445133 C62.7982759,17.4026549 59.6093966,9.11654867 59.6093966,9.11654867 C59.1258621,7.65716814 57.3447414,7.15035398 56.0349138,8.09070796 C52.2523276,10.8018584 51.0955172,14.7586726 52.4298276,18.9780531 L55.8512931,28.3327434 C56.3348276,29.3769027 55.0005172,30.5859292 54.1068966,29.859292 C51.2975,27.5755752 45.3543103,21.2800885 45.3543103,21.2800885 C42.697931,18.7399115 27.7083621,3.40725664 26.704569,2.47300885 C24.6847414,0.59840708 22.1385345,-0.366371681 20.1982759,1.05637168 C18.2151724,2.50964602 17.6643103,4.75672566 19.5800862,7.21141593 C20.1003448,7.87699115 35.2490517,23.8446903 35.2490517,23.8446903 C36.130431,24.7667257 35.0899138,26.0734513 34.1167241,25.1758407 C34.1167241,25.1758407 15.2711207,5.56274336 14.4203448,4.64681416 C12.4923276,2.55849558 9.39525862,2.10053097 7.55905172,3.82247788 C5.76568966,5.50168142 5.80853448,8.25557522 7.76715517,10.4171681 C8.39146552,11.1010619 21.6672414,25.0842478 26.98,30.8118584 C27.335,31.1965487 27.610431,31.709469 27.0840517,32.1918584 C27.077931,32.1979646 26.545431,32.7719469 25.8599138,32.0392035 C24.415431,30.5004425 9.98896552,15.5036283 9.18715517,14.6915044 C7.34482759,12.8230088 4.87206897,11.9376106 2.88284483,13.7572566 C1.07112069,15.4120354 0.777327586,18.3002655 2.85836207,20.3397345 L20.332931,38.7682301 C20.332931,38.7682301 20.9021552,39.4399115 20.2656034,40.0322124 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7388508,24.6690265 L54.1100866,26.2444248 C54.1100866,26.2444248 40.541895,34.3717699 49.7906986,46.8528319 C49.7906986,46.8528319 50.9910752,48.4343363 49.4168108,48.6969027 C49.4168108,48.6969027 48.0393294,49.1731858 46.4650649,46.7429204 C46.4650649,46.7368142 37.1277089,34.8846903 51.7388508,24.6690265 Z",
    id: "Path",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35,4 C35,4 38.6579224,4.53279516 42.0451207,8.02018163 C45.432319,11.5136226 47,16 47,16",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,0 C44,0 46.9293233,1.47795824 49.1909774,5.12761021 C51.4526316,8.77726218 52,13 52,13",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,65.9949482 C18,65.9949482 14.4127678,66.2246817 10.4398776,63.5856923 C6.46698732,60.9467029 4,57 4,57",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,71.9979367 C16,71.9979367 12.556962,72.1470069 8.60759494,69.9109549 C4.65822785,67.6749029 2,64 2,64",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHello);
export default __webpack_public_path__ + "static/media/hello.ebfa46608aa9f5a809e7b40d535b4703.svg";
export { ForwardRef as ReactComponent };